export default __webpack_public_path__ + "static/media/linkedin.3ab0008f.svg";